<template>
  <div>
    <table-view
      :isBusy="isLoading"
      :fields="fields"
      :items="list"
      title="Organ"
    >
      <template v-slot:add>
        <create-organ @init="init" v-if="isCreate"></create-organ>
      </template>
      <template v-slot:license_available="{ value }">
        {{ value == 1 ? "Yes" : "No" }}
      </template>
      <template v-slot:allocation_available="{ value }">
        {{ value == 1 ? "Yes" : "No" }}
      </template>
      <template v-slot:status="{ value }">
        {{ value == 1 ? "Active" : "Deleted" }}
      </template>
      <template v-slot:action="{ item }">
        <div class="d-flex" v-if="isAction(item)">
          <create-organ :item="item" @init="init"></create-organ>
          <delete-button @click="remove(item)"></delete-button>
        </div>
      </template>
    </table-view>
  </div>
</template>

<script>
import menuConstants from "../../assets/constants/menu.constants";
import masterService from "../../assets/services/master.service";
import DeleteButton from "../buttons/DeleteButton.vue";
import TableView from "../table/TableView.vue";
import CreateOrgan from "./create/CreateOrgan.vue";
export default {
  components: { TableView, DeleteButton, CreateOrgan },
  data() {
    return {
      list: [],
      isLoading: false,
    };
  },
  computed: {
    fields() {
      let doc = {
        organ_name: "Organ Name",
        license_cost: "Cost",
        license_available: "License Available",
        allocation_available: "Allocation Available",
        status: "Status",
        action: "Action",
      };
      let list = [];
      Object.keys(doc).forEach((key) => {
        list.push({
          key,
          label: doc[key],
          sortable: true,
          tdClass: key == "action" ? "width-100" : "",
        });
      });
      return list;
    },
    isCreate() {
      return this.hasCreateAccess(menuConstants.ORGAN);
    },
  },
  methods: {
    isAction({ status }) {
      if (!this.hasStatusAccess(menuConstants.ORGAN, 4)) return false;
      return status == 1;
    },
    async remove({ organ_id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure, Do you want to remove this?",
        onConfirm: async () => {
          try {
            let { data } = await masterService.CUDOrgan({
              organ_id,
              dml_indicator: "D",
              status: 4,
            });
            let { status, msg } = data;
            vm.init();
            if (!status) {
              vm.$alert.show(msg);
            }
          } catch (error) {
            vm.isLoading = false;
            vm.$alert.show(error.message);
          }
        },
      });
    },
    async init() {
      const vm = this;
      try {
        vm.list = [];
        vm.isLoading = true;
        let { data } = await masterService.getOrgan();
        let { status, msg, list } = data;
        vm.isLoading = false;
        if (status) {
          vm.list = list.filter((item) => {
            return item.multi_organ_flag == 0;
          });
        } else {
          vm.$alert.show(msg);
        }
      } catch (error) {
        vm.isLoading = false;
        vm.$alert.show(error.message);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
